import React, {useEffect, useContext, useCallback} from 'react';
import styles from './info.module.css';
import Xmark from '../../../assets/images/alertIcon0001.png';
import MenuContext from '../../../context/menuContext';
import useKeyPress from '../../../hooks/useKeyPress';
import Acknowledge from '../acknowledge';
import Info from '.';
import CommandsContext from '../../../context/commandsContext';

function SensorFailed({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {setShowAck, alert, setsensorError, showAck, showInfo, sensorError, onComponent} =
    useContext(MenuContext);
  const {onUpdateCommands} = useContext(CommandsContext);
  const {
    infoAlert,
    xmark,
    sensorFailedBottom,
    sensorFailedBottomText,
    sensorFailed,
    sensorFailedDiv,
  } = styles;

  const onLeft = useCallback(() => {
    onComponent(<Acknowledge />);
    setShowAck(true);
    setsensorError(false);
  }, []);

  const onRight = useCallback(() => {
    setsensorError(false);
    onComponent(<Info />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft, onRight});
    });
  }, [onLeft, onRight]);

  return (
    <div className={sensorFailedDiv}>
      <div className={infoAlert}>
        <img className={xmark} src={Xmark} alt="Information Error" />
        <div className={sensorFailed}>
          <span className={styles.topText}>Sensor Failed</span>
        </div>
        <div className={sensorFailedBottom}>
          <span className={sensorFailedBottomText}>Ack</span>
          <span className={sensorFailedBottomText}>Info</span>
        </div>
      </div>
    </div>
  );
}

export default SensorFailed;
